<template>
	<div id="app">
		<!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {

		}
	}
</script>

<style lang="scss">
	@import './assets/base.css';

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		color: #001A32;
		font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
		font-weight: normal;
		font-style: normal;
		font-style: normal;
		font-weight: bold;
	}
</style>
